export default {
  title: "Fetching data",
  item_class: "Fetching <b class='text-info'>Item Classes</b>",
  attributes: "Fetching <b class='text-info'>Attributes</b>",
  items: "Fetching <b class='text-info'>Items</b>",
  item_attributes: "Fetching <b class='text-info'>Item Attribute Values</b>",
  issues: "Fetching <b class='text-info'>Issues</b>",
  work: "Fetching <b class='text-info'>Work</b>",
  comments: "Fetching <b class='text-info'>Comments</b>",
  identifiers: "Fetching <b class='text-info'>Identifiers</b>",
  users: "Fetching <b class='text-info'>Users</b>",
  explanation:
    "Trying to fetch Workspace data. This process only occurs the first time a Workspace is accessed.",
}
